
<div class="imageWrapper">
  <div class="smallPreview">
    <v-icon v-if="displayFavoriteIcon"
            :class="{favoriteIcon: true, small: true, active: image.favorite, editable: favoriteEditable}"
            @click="evt => toggleFavorite(image, evt)">
      {{ getFavoriteIconName(image) }}
    </v-icon>
    <v-img :src="smallImageUrl" :height="getSmallHeight" :width="getSmallWidth"
           :class="{smallImage: true, landscape: landscape, portrait: !landscape}" @click="onImageClick" alt=""
           ref="small" @load="onSmallLoaded"/>
    <span class="label">{{ displayId }}</span>
  </div>
  <div class="largePreview">
    <v-dialog v-if="mayLoadLargeImage || dialog" content-class="largePreviewDialog" v-model="dialog"
              :max-width="largeImageWidth()">
      <v-icon v-if="displayFavoriteIcon && largeLoaded"
              class="favoriteIcon large"
              :class="{editable: favoriteEditable}"
              @click="evt => toggleFavorite(image, evt)">{{ getFavoriteIconName(image) }}
      </v-icon>
      <v-icon class="closeIcon" @click="closeDialog">close</v-icon>
      <v-progress-circular v-if="! largeLoaded" class="largePreviewLoadingProgress" :size="70" indeterminate/>
      <v-img :src="largeImageUrl" :lazy-src="smallImageUrl" contain alt="" ref="large" class="largeImage"
             :max-height="largeImageMaxHeight"
             @load="onLargeLoaded">
      </v-img>
      <span v-if="largeLoaded" class="label">{{ displayId }}</span>
      <v-icon v-if="hasPreviousPreview" class="previous" size="60px" @click="openPrevious">navigate_before</v-icon>
      <v-icon v-if="hasNextPreview" class="next" @click="openNext" size="60px">navigate_next</v-icon>
    </v-dialog>
  </div>
</div>
